// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Kmej","colMin":"styles_colMin__3zGaq"};